import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CustomFieldsListLazy = React.lazy(
	() => import(/* webpackChunkName : 'CustomFieldsList' */ './components')
);

export default (store) => ({
	path: ':userTypeId',
	element: <AsyncLoading component={<CustomFieldsListLazy />} />,
});
